<template>
  <div class="user-management">
    <template>
      <h4 style="color: aliceblue;margin-top: -30px">
        黑名单管理
      </h4>
    </template>
    <el-row :gutter="40">
      <el-col :span="24" :xs="24">
        <el-form ref="queryForm" :inline="true" :model="queryParams" label-width="68px" size="small">
          <el-form-item>
            <el-button icon="el-icon-plus" type="primary" @click="handleAdd(1)">新增企业
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-plus" type="primary" @click="handleAdd(2)">新增车牌号
            </el-button>
          </el-form-item>
          <el-form-item  prop="coId">
            <el-select v-model="queryParams.coId" filterable clearable placeholder="所属企业">
              <el-option v-for="item in company2" :key="item.value" :label="item.lable" :value="parseInt(item.value)" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input v-model="queryParams.plateNo" placeholder="车牌号码" />
          </el-form-item>
          <el-form-item  prop="vehicleType">
            <el-select v-model="queryParams.vehicleType" filterable clearable placeholder="车辆类别">
              <el-option v-for="item in vehicleType" :key="item.code" :label="item.name" :value="parseInt(item.code)" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="handleQuery">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
            <!-- <el-button type="warning" size="small" @click="relieve">解除企业黑名单</el-button> -->
            <el-button
              type="primary"
              icon="el-icon-upload2"
              style="margin-left:15px"
              @click="handleImport"
              >批量导入
            </el-button>
            <el-button
              :disabled="multiple"
              type="danger" icon="el-icon-delete"
              style="margin-left:15px"
              @click="moreDelete"
              >批量删除
            </el-button>
          </el-form-item>
        </el-form>

        <el-table v-loading="loading" element-loading-text="数据载入中" element-loading-spinner="el-icon-loading"
          :data="pageList" :show-overflow-tooltip="true" @selection-change="handleSelectionChange">
          <el-table-column align="center" type="selection" width="50" />
          <el-table-column align="center" label="企业名称" prop="coName" />
          <!-- <el-table-column align="center" label="登记人姓名" prop="name" width="100" />
          <el-table-column align="center" label="登记人手机号" prop="phone" width="120" /> -->
          <el-table-column align="center" label="车牌号码" prop="plateNo" width="150" />
          <el-table-column align="center" label="车牌颜色" prop="plateColor" width="120" >
            <template slot-scope="scope">
              <span v-if="scope.row.plateColor == 1">黑色</span>
              <span v-if="scope.row.plateColor == 2">白色</span>
              <span v-if="scope.row.plateColor == 5">蓝色</span>
              <span v-if="scope.row.plateColor == 6">黄色</span>
              <span v-if="scope.row.plateColor == 9">绿色</span>
              <span v-if="scope.row.plateColor == 99">未知</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="车辆类别" prop="vehicleType" width="120" >
            <template slot-scope="scope">
              <span v-if="scope.row.vehicleType == 1">小轿车</span>
              <span v-if="scope.row.vehicleType == 2">客车</span>
              <span v-if="scope.row.vehicleType == 3">货车</span>
              <span v-if="scope.row.vehicleType == 4">危化品车</span>
              <span v-if="scope.row.vehicleType == 6">营运车</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="有效期始" prop="validityPeriodStart" width="120" />
          <el-table-column align="center" label="有效期止" prop="validityPeriodEnd" width="120" />
          <el-table-column align="center" label="理由" prop="reason" width="150" show-overflow-tooltip/>
          <el-table-column align="center" label="创建时间" prop="createTime" width="150" />
          <el-table-column align="center" label="操作" width="180">
            <template slot-scope="scope">
              <el-button type="danger" icon="el-icon-delete" size="mini" circle plain
                @click.stop="handleDelete(scope.row)" />
            </template>
          </el-table-column>
        </el-table>

        <commonPagination :page="pagination" :pageSizes="[10, 20]" :getList="handleQuery">
        </commonPagination>
      </el-col>
    </el-row>
    <!-- 新增或修改参数配置对话框 -->
    <el-dialog :title="dialog.title" :visible.sync="dialog.visible" width="800px">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-row>
          <el-col :span="12" v-if="form.blackType == 1">
            <el-form-item label="企业名称" prop="coId">
              <el-select v-model="form.coId" filterable placeholder="请输入或选择">
                <el-option v-for="item in company1" :key="item.value" :label="item.lable" :value="parseInt(item.value)" />
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="登记人姓名" prop="name">
              <el-input v-model="form.name" placeholder="请输入联系人姓名" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="登记人手机" prop="phone">
              <el-input v-model="form.phone" placeholder="请输入手机号" type="number" oninput="if(value.length>11)value=value.slice(0,11)" />
            </el-form-item>
          </el-col> -->
          <el-col :span="12" v-if="form.blackType == 2">
            <el-form-item label="车牌号" prop="plateNo">
              <el-input v-model="form.plateNo" placeholder="请输入车牌号"  />
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.blackType == 2">
            <el-form-item label="车牌颜色" prop="plateColor">
              <el-select v-model="form.plateColor" placeholder="请选择">
                <el-option v-for="item in platecolor" :key="item.value" :label="item.name" :value="parseInt(item.code)" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.blackType == 2">
            <el-form-item label="车型类别" prop="vehicleType">
              <el-select v-model="form.vehicleType" placeholder="请选择">
                <el-option v-for="item in vehicleType" :key="item.value" :label="item.name" :value="parseInt(item.code)" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" >
            <el-form-item label="有效期始" prop="validityPeriodStart">
              <el-date-picker v-model="form.validityPeriodStart"  value-format="yyyy-MM-dd"
                type="date" :picker-options="pickerOptions"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12" >
            <el-form-item label="有效期止" prop="validityPeriodEnd">
              <el-date-picker v-model="form.validityPeriodEnd"  value-format="yyyy-MM-dd"
                type="date" :picker-options="pickerOptions"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="理由" prop="reason">
              <el-input v-model="form.reason" placeholder="请输入理由" maxlength="50"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSubmit" :loading="loadingbut" v-if="!buttonVisible">{{buttontext}}</el-button>
        <el-button @click="dialog.visible = false">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="解除企业黑名单"
      :visible.sync="dialogVisible"
      width="40%"
      custom-class="hmdgl"
      :close-on-click-modal="false"
    >
      <el-form :model="dataForm" :rules="rules">
        <el-form-item label="企业名称" prop="coId">
          <el-select v-model="dataForm.coId" filterable placeholder="请输入或选择">
            <el-option v-for="item in company2" :key="item.value" :label="item.lable" :value="parseInt(item.value)" />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogSubmit" :loading="loadingbut" v-if="!buttonVisible">{{buttontext}}</el-button>
      </span>
    </el-dialog>

    <el-dialog title="批量导入黑名单" :visible.sync="upload.open" width="400px" append-to-body>
      <el-upload
        ref="upload2"
        :limit="1"
        action="#"
        accept=".xlsx, .xls"
        :file-list="fileList"
        :http-request="moreImport"
        :before-upload="beforeUpload"
        :on-change="handleChange"
        :on-remove="handleRemove"
        :disabled="upload.isUploading"
        :on-progress="handleFileUploadProgress"
        :auto-upload="false"
        drag
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip text-center" slot="tip">
          <span style="color: aliceblue;">仅允许导入xls、xlsx格式文件。</span>
          <el-link type="primary" :underline="false" style="font-size:12px;vertical-align: baseline;color: aqua;" href="/api/dqi-hymanage/upload/file/image/20230424/6446257c90855c3cad5afc6d">下载模板</el-link>
        </div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="loadingbut" @click="submitFileForm">{{uploadText}}</el-button>
        <el-button @click="upload.open = false">取 消</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import commonPagination from "@/components/commonPagination.vue";
  export default {
    name: "person-management",
    components: {
      commonPagination
    },
    props: {},
    data() {
      return {
        pickerOptions: {
          disabledDate(time) {
          return time.getTime() < Date.now()- 8.64e7;
        }},
        company1:JSON.parse(localStorage.getItem('company')),
        company2:[],
        platecolor:JSON.parse(sessionStorage.getItem('dictionary')).PLATECOLOR,
        vehicleType:JSON.parse(sessionStorage.getItem('dictionary')).VEHICLETYPE,
        dialogVisible:false,
        loadingbut:false,
        buttontext:"提 交",
        buttonVisible:false,
        blackType:1,
        dataForm:{ids:[]},
        loading: true,
        // 选中数组
        ids: [],
        // 非单个禁用
        single: true,
        // 非多个禁用
        multiple: true,
        queryParams: {

        },
        queryParam: {
          pageIndex: 0,
          pageRow: 1000,
        },
        pagination: {
          pageIndex: 1,
          pageRow: 10,
          total: 0
        },
        pageList: [],
        dialog: {
          title: undefined,
          visible: false,
          flag: undefined
        },
        apiUrl: {
          delApi: 'GET_delVehicleBlack',
          indexApi: 'POST_vehicleBlackList',
          Enterpriseinfo: 'GET_getCoIdBlack'
        },
        upload: {
          open: false,
          title: "",
          isUploading: false,
          updateSupport: 0,
        },
        uploadText:"",
        fileList: [],
        // 表单参数
        form: {
          coId: "",
          coName: "",
          id: 0,
          name: "",
          phone: "",
          plateNo: "",
          plateColor: "",
          vehicleType: "",
          validityPeriodStart: "",
          validityPeriodEnd: "",
          reason: "",
          blackType:1
        },
        // 表单校验
        rules: {
            coId: [{
              required: true,
              message: "企业不能为空",
              trigger: "blur"
            }],
            name: [{
              required: true,
              message: "姓名不能为空",
              trigger: "blur"
            }],
            phone: [{
              required: true,
              pattern: /\d{11}$/,
              message: "请输入正确的手机号码",
              trigger: "blur"
            }],
            plateNo: [{
              required: true,
              message: "不能为空",
              trigger: "blur"
            }],
            plateColor: [{
              required: true,
              message: "不能为空",
              trigger: "blur"
            }],
            vehicleType: [{
              required: true,
              message: "不能为空",
              trigger: "blur"
            }],
            validityPeriodStart: [{
              required: true,
              message: "不能为空",
              trigger: "blur"
            }],
            validityPeriodEnd: [{
              required: true,
              message: "不能为空",
              trigger: "blur"
            }],
            reason: [{
              required: true,
              message: "不能为空",
              trigger: "blur"
            }],
        }
      };
    },
    methods: {
      async loadData() {
        this.handleQuery();
      },
      handleQuery(obj = {}) {
        if ("pageNo" in obj) {
          this.queryParams.pageIndex = this.pagination.pageIndex = obj.pageNo;
        } else {
          this.queryParams.pageIndex = this.pagination.pageIndex;
        }
        if ("pageSize" in obj) {
          this.queryParams.pageRow = this.pagination.pageRow = obj.pageSize;
        } else {
          this.queryParams.pageRow = this.pagination.pageRow;
        }
        this.$http[this.apiUrl.indexApi](this.queryParams).then(response => {
          const {
            data,
            total
          } = response;
          this.pageList = data;
          this.pagination.total = total;
          this.loading = false;
        });
      },
      handleReset() {
        this.pagination = {
          pageIndex: 1,
          pageRow: 10,
          total: 0
        };
        this.queryParams = {

        };
        this.handleQuery();
      },

      handleAdd(type) {
        this.blackType = type;
        this.resetForm();
        if(type == 1){
          this.dialog = {
          title : "新增企业黑名单",
          visible: true,
          flag: true
        };
        }else{
          this.dialog = {
          title : "新增车牌黑名单",
          visible: true,
          flag: true
        };
        }
        
      },
     
      handleSubmit: function() {
        this.$refs["form"].validate(valid => {
          if (valid) {
           
            if(this.dialog.flag){
              let day1 = new Date(this.form.validityPeriodStart);
              let day2 = new Date(this.form.validityPeriodEnd);
              if(day1 <= day2){
                this.loadingbut = true;
                this.buttontext = "提交中..."
                this.$http.POST_addVehicleBlack(this.form).then(res => {
                  if (res.code == '00000') {
                    this.$message.success(res.data);
                    this.dialog.visible = false;
                    this.loadingbut = false;
                    this.buttontext = "提 交";
                    this.handleQuery();
                    this.getCompany();
                  } else {
                    this.loadingbut = false;
                    this.buttontext = "提 交";
                    this.$message.error(res.msg);
                  }
                });
              }else{
                this.$message.error("有效期止不能早于有效期始!")
              }
            }
          }
        });
      },
    relieve(){
      this.dialogVisible = true;
      this.loadingbut = false;
      this.buttontext = "提 交";
      this.getCompany();
    },
    dialogSubmit(){
      if(this.dataForm.coId == undefined){
        return this.$message.error("企业不能为空!");
      }
      this.loadingbut = true;
      this.buttontext = "提交中..."
      this.$http.GET_delCoIdBlack({ paramsID: "/" + this.dataForm.coId }).then(res=>{
          if(res.code=='00000'){
             this.$message.success("解除企业黑名单成功");
             this.pageIndex = 1;
             this.handleQuery();
             this.dialogVisible = false;
             this.loadingbut = false;
             this.buttontext = "提 交";
          }else{
             this.$message.error(res.msg);
             this.loadingbut = false;
             this.buttontext = "提 交";
          }
        })
    },
    handleDelete(row) {
        const id = row.id;
        this.$confirm('确定要删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http[this.apiUrl.delApi]({
            paramsID: "/" +id
          }).then(response => {
            if(response.code == '00000'){
                    this.$message.success("删除成功");
                    this.handleQuery();
                    this.getCompany();
                }else{
                  this.$message.error(response.msg);
                }
          });
        }).catch(() => {});
      },
    moreDelete() {
        this.dataForm.ids = this.ids
        this.$confirm('确定要删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.POST_delBatchCar(this.dataForm).then(response => {
            if(response.code == '00000'){
                    this.$message.success(response.data);
                    this.handleQuery();
                    this.getCompany();
                }else{
                  this.$message.error(response.msg);
                }
          });
          console.log(this.dataForm.ids);
        }).catch(() => {});
      },
      // 多选框选中数据
      handleSelectionChange(selection) {
          this.ids = [];
          selection.forEach(s => {
                  this.ids.push(s.id)
            })
          //this.ids = selection.map(item => (item.id));
          this.single = selection.length !== 1;
          this.multiple = !selection.length;
      },
      getCompany(){
        this.company2 = [];
        this.$http[this.apiUrl.Enterpriseinfo](this.queryParam).then(res => {
          if(res.data.length>0){
            res.data.forEach((element, key) => {
              this.company2.push({
                lable: element.coName,
                value: element.id,
              });
            });
          }
        });
      },

      /** 导入按钮操作 */
      handleImport() {
        this.upload.title = "批量导入";
        this.upload.open = true;
        this.upload.isUploading = false;
        this.loadingbut = false;
        this.uploadText = "提 交"
      },

      // 文件上传中处理
      handleFileUploadProgress(event, file, fileList) {
        this.upload.isUploading = true;
        this.uploadText = "批量导入中..."
      },

      // 文件上传前的校验 —— 常见的校验有：校验文件类型，文件大小
      beforeUpload(file,fileList) {
          // 允许上传的文件格式列表
          let acceptList = ["xlsx", "xls"]
          // 根据文件名获取文件的后缀名
          let fileType = file.name.split('.').pop().toLowerCase()
          // 判断文件格式是否符合要求
          if (acceptList.indexOf(fileType) === -1) {
              this.$message.error('只能上传 xlsx/xls 格式的文件 !');
              return false
          }
          // 判断文件大小是否符合要求
          // if (file.size / 1024 / 1024 > 1) {
          //     this.$message.error('上传文件大小不能超过 1M !');
          //     return false
          // }
      },
      handleRemove(file, fileList) {
        this.fileList = [];
      },
      handleChange(file, fileList) {
        this.fileList = fileList.slice(-1);
      },
      moreImport(item) {
        this.loadingbut = true;
        this.uploadText = "提交中...";
        let formData = new FormData();
        formData.append('file', item.file);
        this.$axios({
          method: 'post',
          url: '/dqi-hymanage/vehicleBlack/uploadCarData',
          timeout: 50000,
          data: formData
        }).then(res => {
          if(res.code=='00000'){
            this.upload.open = false;
            this.upload.isUploading = false;
            this.$refs.upload2.clearFiles();
            this.fileList = [];
            this.$message.success({message:res.data,duration: 5000});
            this.handleQuery();
           }else{
             this.$message.error({message:res.msg,duration: 5000});
             this.upload.isUploading = false;
             this.$refs.upload2.clearFiles();
             this.fileList = [];
             this.uploadText = "提 交";
           }
        })
      },
      // 提交上传文件
      submitFileForm() {
        if(this.fileList.length == 1){
          this.$refs.upload2.submit();
         }else{
          this.$message.error("请先上传需要导入数据的xlsx/xls格式的文件!")
         }
      },

      // 表单重置
      resetForm() {
        this.form = {
          coId: "",
          coName: "",
          id: 0,
          name: "",
          phone: "",
          plateNo: "",
          plateColor: "",
          vehicleType: "",
          validityPeriodStart: "",
          validityPeriodEnd: "",
          reason: "",
          blackType:this.blackType
        };
        this.loadingbut = false;
        this.buttontext = "提 交";
        if (this.$refs["form"]) {
          //this.$nextTick(() => {
            this.$refs["form"].resetFields();
          //})
        }
      }
    },
    created() {
      this.loadData();
      this.getCompany();
    },
    watch: {}
  };
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/views/xtgl/hmdgl.vue